module.exports = __webpack_public_path__ + "media/images/icons/rotate_left-ffb6e501c84b7bd2364b4aba7f8778cc.svg";